import { Row, message } from "antd";
// import PropTypes from "prop-types";
import classes from "../Pages.module.css";
import DataField from "./DataField";
import dayjs from "dayjs";
const BasicDetail = (props) => {
  const handleChange = (e, param) => {
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = e.target.value;
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

  const handleSChange = (val, param) => {
    // console.log(val, "Truwwww");
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = val;
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

  const handleDChange = (date, dateString, param) => {
    props.setData((data) => {
      const newdata = [...data["prodHdr"]];
      newdata[0][param] = dateString;
      return {
        ...data,
        prodHdr: newdata,
      };
    });
  };

  // const handleTChange = (time, timeString, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["reqHdr"]];
  //     // Assuming `timeString` is in the format "HH:mm:ss"
  //     newdata[0][param] = timeString;
  //     return {
  //       ...data,
  //       reqHdr: newdata,
  //     };
  //   });
  // };

  // const handleDTChange = (date, dateString, param) => {
  //   props.setData((data) => {
  //     const newdata = [...data["prodHdr"]];
  //     newdata[0][param] = dateString;

  //     // Calculate the total time if both from_req_time and to_req_time are filled
  //     const fromTime =
  //       param === "from_time" ? dateString : data.prodHdr[0].from_time;
  //     const toTime = param === "to_time" ? dateString : data.prodHdr[0].to_time;

  //     if (fromTime && toTime) {
  //       const from = dayjs(fromTime, "DD-MM-YYYY HH:mm:ss");
  //       const to = dayjs(toTime, "DD-MM-YYYY HH:mm:ss");

  //       if (to.isAfter(from)) {
  //         const diff = to.diff(from, "hour", true); // Calculate the difference in hours
  //         newdata[0]["no_of_hrs"] = diff.toFixed(2); // Update the total with the calculated difference
  //       } else {
  //         message.error("To Time should be after From Time");
  //         newdata[0]["no_of_hrs"] = "";
  //       }
  //     }

  //     return {
  //       ...data,
  //       prodHdr: newdata,
  //     };
  //   });
  // };
  return (
    <div>
      <p></p>
      <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
        {!props.create && (
          <DataField
            editMode={props.editMode}
            lg={12}
            md={24}
            name="Requisition Code"
            param="REQ_CODE"
            value={props.data.req_code}
          />
        )}
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleSChange}
          options={props.vd}
          type="Select"
          name="Transporter"
          id="vendor_code"
          required="True"
          param="vendor_code"
          value={props.data.vendor_code}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="bill_date"
          required="True"
          name="Transporter Bill Date"
          param="bill_date"
          value={props.data.bill_date}
          rules={[{ message: "missing name" }]}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="invoice_date"
          // required="True"
          name="Transaction Date"
          param="invoice_date"
          value={props.data.invoice_date}
          rules={[{ message: "missing name" }]}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="f_date"
          required="True"
          name=" Gr From Date"
          param="f_date"
          value={props.data.f_date}
          rules={[{ message: "missing name" }]}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleDChange}
          type="Date"
          id="t_date"
          required="True"
          name="Gr To Date"
          param="t_date"
          value={props.data.t_date}
          rules={[{ message: "missing name" }]}
        />
        {/* <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleTChange}
          type="Time"
          id="Req_time"
          required="True"
          name="Requisition Time"
          param="Req_time"
          value={props.data.req_time}
          rules={[{ message: "missing name" }]}
        /> */}
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Reference No"
          id="reference_no"
          // required="True"
          param="reference_no"
          value={props.data.reference_no}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Remarks"
          id="remarks"
          // required="True"
          param="remarks"
          value={props.data.remarks}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Total Invoice Amount"
          id="net_amount"
          // required="True"
          param="net_amount"
          value={props.data.net_amount}
          disabled={true}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Transporter Freight"
          id="freight_net_amount"
          // required="True"
          param="freight_net_amount"
          value={props.data.freight_net_amount}
          disabled={true}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Tagged Freight"
          id="act_amt"
          // required="True"
          param="act_amt"
          value={props.data.act_amt}
          disabled={true}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Short"
          id="short"
          // required="True"
          param="short"
          value={props.data.short}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Tot Short"
          id="tot_short"
          // required="True"
          param="tot_short"
          value={props.data.tot_short}
        />
        <DataField
          editMode={props.editMode}
          lg={4}
          md={24}
          handleChange={handleChange}
          type="Input"
          name="Left Qty"
          id="left_qty"
          // required="True"
          param="left_qty"
          value={props.data.left_qty}
        />{" "}
        {/* <DataField
          editMode={props.editMode}
          lg={5}
          md={24}
          handleChange={handleSChange}
          options={props.ad.EMPLOYEE_CODE}
          type="Select"
          name="Requested By"
          required="True"
          id="employee"
          param="emp_cd"
          value={props.data.emp_cd}
        /> */}
      </Row>
    </div>
  );
};

export default BasicDetail;
